var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.as,
    _vm._b(
      {
        tag: "component",
        staticClass: "jade-text",
        class: _vm.computedClassList,
      },
      "component",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }